module.exports = "<a ng-if=\"purchase.status === 'UNAUTHORIZED'\" class=\"btn btn-default btn-xs\" ng-click=authorize()><span class=\"glyphicon glyphicon-ok-circle\" aria-hidden=true></span>&nbsp;<span class=\"hidden-xs ng-scope\" translate=AUTHORIZE>Authorize</span></a>";


//////////////////
// WEBPACK FOOTER
// ./js/actions/authorizepurchase.html
// module id = 433
// module chunks = 0